/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
// import moment from "moment";
import { LiButton } from "../../Utils/CustomComponent";
import { setLoanAgingTab } from "../../store/reducers/dashboardSlice";
// import { useAbortController } from "../../hooks/useAbortController";
// import { loadingTypes } from "../../Utils/constant";
import DoughnutChart from "../DoughnutChart";
import InsuranceMeter from "./InsuranceMeter";
import DoughnutChartBorrower from "./DoughnutChartBorrower";

const DoughnutAndMeterBorrower = () => {
  const dispatch = useDispatch();
  const loanAgingTab = useSelector(
    (state) => state.dashboard.kpis.loanAgingTab
  );
  const handleActiveTab = (value) => {
    dispatch(setLoanAgingTab(value));
  };
  return (
    <div className=" bg-white h-100 rounded border border-primary">
      <ul className="nav nav-tabs bg-white">
        {tabConfig?.map((data, index) => (
          <LiButton
            key={index}
            activeTab={loanAgingTab}
            setActiveTab={handleActiveTab}
            label={data.label}
            value={index}
          />
        ))}
      </ul>
      <div className="d-flex justify-content-center align-items-center">
        {tabConfig?.[loanAgingTab]?.renderComponent()}
      </div>
    </div>
  );
};

export default DoughnutAndMeterBorrower;

let tabConfig = [
  {
    label: "Loan Aging",
    renderComponent: (_, formOptions) => <DoughnutChartBorrower />,
  },
  // {
  //   label: "Insurance Expiry - Next 30 Days",
  //   renderComponent: (_, formOptions) => <InsuranceMeter />,
  // },
];
